import React, { useState } from "react";
import classes from "../style/Style.module.css";
import "../style/LoginScreen.scss";
import { useNavigate } from "react-router-dom";
import { ROUTE_OTP_VERIFICATION } from "../Routes";
import axios from "../libs/axiosConfig";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import { useDispatch } from "react-redux";
import { setMobileNumber } from "../Store/MobileSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";

const PhoneNumber = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();

  const Navigate = useNavigate();

  const handleInputChange = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    setPhoneNumber(input);
    dispatch(setMobileNumber(input));
  };

  const handleClearButtonClick = () => {
    setPhoneNumber("");
  };

  const handleSubmit = async () => {
    if (!phoneNumber) {
      Toast.error("Please enter valid mobile number");
      // console.error("Mobile number is required.");
      // Toast.success("success");
      return;
    }

    if (phoneNumber.length !== 10) {
      Toast.error("Please enter a 10-digit mobile number");
      // console.error("Phone number should be 10 digits long.");
      return;
    }
    const countryCode = "+91";
    const apiUrl =
      "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";

    const requestBody = {
      loginUserInfo: {
      countryCode: "+91",
      mobileNumber: phoneNumber,
      job: "sendOtp"
      }
    };

    try {
      const response = await axios.post(apiUrl, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (response.status === 200) {
        const responseData = response.data;
        Navigate(ROUTE_OTP_VERIFICATION, {
              state: {
                phoneNumber,
              },
            });
        
        // if (responseData.message === "Customer already exists.") {
        //   // Toast.error(responseData.message);
        //   await callSecondApi();
        // } else {
        //   Toast.success(responseData.message);

        //   Navigate(ROUTE_OTP_VERIFICATION, {
        //     state: {
        //       phoneNumber,
        //       userId: responseData.data.userId,
        //       mobileOTP: responseData.data.mobileOTP,
        //       ResponseFristApi: response.status === 200,
        //     },
        //   });
        // }
      } else {
        //console.error("API request failed:", response.statusText);
        Toast.error(response.data.message);
      }
    } catch (error) {
      //console.error("An error occurred:", error);
      Toast.error(
        error.response.data.errorMessage +
        " " +
        error.response.data.message || "Error"
      );
    }
  };

  const callSecondApi = async () => {
    const countryCode = "+91";
    const secondApiUrl =
      "https://partnerapp.ambrela.money/api/DexterrCustomerSendOtp";
    const secondApiRequestBody = {
      countryCode,
      phoneNumber,
      userId: "",
      otp_for: "login",
    };

    try {
      const secondApiResponse = await axios.post(
        secondApiUrl,
        secondApiRequestBody,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (secondApiResponse.status === 200) {
        // Toast.success(secondApiResponse.data.message);

        const responseData = secondApiResponse.data;

        Navigate(ROUTE_OTP_VERIFICATION, {
          state: {
            phoneNumber,
            userId: responseData.userId,
            mobileOTP: responseData.mobileOTP,
            SecondApiRes: secondApiResponse.status === 200,
          },
        });
      } else {
        //console.error("Second API request failed:");
        Toast.error(secondApiResponse.message);
      }
    } catch (error) {
      //console.error("An error occurred:", error);
    }
  };

  return (
    <div className="Login_Mobile_Main_Container">
      <header className="Login_Splash1Header">
        <img alt="" src={NewDexterLogo} className="Login_DexterLogo" />
      </header>
      <div className="Login_Input_Div_Container">
        <p className="Login_Input_Heading_text">Enter your mobile number</p>
        <span className="Login_Input_Sub_heading">Let's get started.</span>
        <div className="Login_Input_Filed_Box">
          <div className="Login_Input_Inner_Container">
            <span className="Login_Enter_mobile_text">+91 </span>
            <input
              className={classes.Input_Filed_MobileNO}
              value={phoneNumber}
              onChange={handleInputChange}
              maxLength={10}
            />
            <button
              className="Login_Cross_button"
              onClick={handleClearButtonClick}
            />
          </div>
        </div>
        <button className="Login_Submit_button" onClick={handleSubmit}>
          Submit
        </button>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PhoneNumber;
